import React from 'react';
import SearchField from '../../Search';
import useLiteratureCurrentView from '../hooks/useLiteratureCurrentView';
import { useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import { useDebouncedCallback } from 'use-debounce';
import { changeFilter, clearDocumentQuery, clearFaultQuery, executeDocumentQuery, executeFaultQuery, executeServiceLogQuery, clearServiceLogQuery } from '../../../redux/libraryFiltersSlice';
import { usePhoneMode } from '../../../hooks';

export function NavServiceLogSearchField() {
    const dispatch = useDispatch();
    const { isInServiceLogList } = useLiteratureCurrentView();
    const theme = useTheme();
    const narrowSearch = useMediaQuery(theme.breakpoints.down("md"));
    const { phoneMode } = usePhoneMode();

    const { serviceLogQuery: executedQuery, serviceLogSearchTextBoxValue: workingQuery } = useSelector((state) => state.libraryFilters)

    const debouncedExecutedQuery = useDebouncedCallback(() => {
        handleExecuteQuery();
    }, 1000)

    if (!isInServiceLogList) {
        return null;
    }

    let searchText = 'Search by Serial, Hull Id or Service Type';
    if (narrowSearch) {
        searchText = 'Search for Service Log';
    }

    const handleClearQuery = () => {
        dispatch(clearServiceLogQuery());
    }

    const handleFilterValueChanged = (value) => {
        dispatch(changeFilter({ fieldName: 'serviceLogSearchTextBoxValue', value }));
    }

    const handleExecuteQuery = () => {
        dispatch(executeServiceLogQuery(workingQuery));
    }


    return (
        <SearchField
            placeholder={searchText}
            query={workingQuery}
            onChange={(event) => {
                handleFilterValueChanged(event.target.value);
                debouncedExecutedQuery();
            }}
            onKeyDown={(event) => {
                if (event.key == 'Enter') {
                    handleExecuteQuery();
                }
            }}
            onClearQuery={handleClearQuery}
            showClear={!!executedQuery}
            narrow={phoneMode}
        />
    );
}

export function NavFaultSearchField() {
    const dispatch = useDispatch();
    const { isInFaultList } = useLiteratureCurrentView();
    const theme = useTheme();
    const narrowSearch = useMediaQuery(theme.breakpoints.down("md"));
    const { phoneMode } = usePhoneMode();

    const { faultQuery: executedQuery, faultSearchTextBoxValue: workingQuery } = useSelector((state) => state.libraryFilters)

    const debouncedExecutedQuery = useDebouncedCallback(() => {
        handleExecuteQuery();
    }, 1000)

    if (!isInFaultList) {
        return null;
    }

    let searchText = 'Search by Fault Name or Description';
    if (narrowSearch) {
        searchText = 'Search by Fault';
    }

    const handleClearQuery = () => {
        dispatch(clearFaultQuery());
    }

    const handleFilterValueChanged = (value) => {
        dispatch(changeFilter({ fieldName: 'faultSearchTextBoxValue', value }));
    }

    const handleExecuteQuery = () => {
        dispatch(executeFaultQuery(workingQuery));
    }


    return (
        <SearchField
            placeholder={searchText}
            query={workingQuery}
            onChange={(event) => {
                handleFilterValueChanged(event.target.value);
                debouncedExecutedQuery();
            }}
            onKeyDown={(event) => {
                if (event.key == 'Enter') {
                    handleExecuteQuery();
                }
            }}
            onClearQuery={handleClearQuery}
            showClear={!!executedQuery}
            narrow={phoneMode}
        />
    );
}

export function NavDocumentSearchField() {
    const dispatch = useDispatch();
    const { isInDocumentListView } = useLiteratureCurrentView();
    const theme = useTheme();
    const narrowSearch = useMediaQuery(theme.breakpoints.down("md"));
    const { phoneMode } = usePhoneMode();

    const { query: executedQuery, searchTextBoxValue: workingQuery } = useSelector((state) => state.libraryFilters)

    const debouncedExecutedQuery = useDebouncedCallback(() => {
        handleExecuteQuery();
    }, 1000)

    if (!isInDocumentListView) {
        return null;
    }

    let searchText = 'Search by Keyword, Serial, or Model Number';
    if (narrowSearch) {
        searchText = 'Search Keyword, Serial, Model';
    }
    if (phoneMode) {
        searchText = 'Search';
    }

    const handleClearQuery = () => {
        dispatch(clearDocumentQuery());
    }

    const handleFilterValueChanged = (value) => {
        dispatch(changeFilter({ fieldName: 'searchTextBoxValue', value }));
    }

    const handleExecuteQuery = () => {
        dispatch(executeDocumentQuery(workingQuery));
    }


    return (
        <SearchField
            placeholder={searchText}
            query={workingQuery}
            onChange={(event) => {
                handleFilterValueChanged(event.target.value);
                debouncedExecutedQuery();
            }}
            onKeyDown={(event) => {
                if (event.key == 'Enter') {
                    handleExecuteQuery();
                }
            }}
            onClearQuery={handleClearQuery}
            showClear={!!executedQuery}
            narrow={phoneMode}
        />
    );
}